import type { CSSProperties } from 'react';

// Muted Prism theme that reads from --syntax-* CSS variables defined in
// globals.css, so the same theme object adapts to both light and dark mode.
export const ryeSyntaxTheme: { [key: string]: CSSProperties } = {
  'code[class*="language-"]': {
    color: 'var(--syntax-text)',
    fontFamily:
      'var(--font-mono, ui-monospace, SFMono-Regular, Menlo, Consolas, "Liberation Mono", monospace)',
    fontSize: '13px',
    lineHeight: 1.65,
    background: 'transparent',
    textAlign: 'left',
    whiteSpace: 'pre',
    wordSpacing: 'normal',
    wordBreak: 'normal',
    tabSize: 2,
    hyphens: 'none',
  },
  'pre[class*="language-"]': {
    color: 'var(--syntax-text)',
    background: 'transparent',
    margin: 0,
    padding: '20px 22px',
    overflow: 'auto',
    width: '100%',
    boxSizing: 'border-box',
  },
  comment: { color: 'var(--syntax-dim)', fontStyle: 'italic' },
  prolog: { color: 'var(--syntax-dim)' },
  punctuation: { color: 'var(--syntax-muted)' },
  property: { color: 'var(--syntax-text)' },
  'attr-name': { color: 'var(--syntax-text)' },
  tag: { color: 'var(--syntax-text)' },
  number: { color: 'var(--syntax-accent)' },
  boolean: { color: 'var(--syntax-accent)' },
  string: { color: 'var(--syntax-accent)' },
  'attr-value': { color: 'var(--syntax-accent)' },
  'template-string': { color: 'var(--syntax-accent)' },
  keyword: { color: 'var(--syntax-subtle)' },
  'class-name': { color: 'var(--syntax-text)' },
  function: { color: 'var(--syntax-text)' },
  'function-variable': { color: 'var(--syntax-text)' },
  operator: { color: 'var(--syntax-muted)' },
  variable: { color: 'var(--syntax-text)' },
};
